/* eslint-disable no-unused-vars */
import ReducedMealBreakReasonOptions from '@/constants/booking/timesheets/ReducedMealBreakReasonOptions'

/**
 * Represents the request to end a meal break for a time entry.
 */
export class TimeEntryMealBreakEndRequest {
  /**
   * @param {Object} params
   * @param {?MealBreakEndFormRequestModel} params.form
   * @param {number} params.bookingId
   */
  constructor({ form, bookingId }) {
    /**
     * The form data. Nullable if the user is not required to fill in the form.
     * @type {?MealBreakEndFormRequestModel}
     */
    this.form = form ? new MealBreakEndFormRequestModel(form) : null

    /**
     * The booking ID associated with the time entry.
     * @type {number}
     */
    this.bookingId = bookingId
  }
}

/**
 * Represents the form data for the meal break end request.
 */
export class MealBreakEndFormRequestModel {
  /**
   * @param {Object} params
   * @param {?ReducedMealBreakReasonRequestModel} params.reducedMealBreak
   */
  constructor({ reducedMealBreak }) {
    /**
     * Details about the reduced meal break. Nullable.
     * @type {?ReducedMealBreakReasonRequestModel}
     */
    this.reducedMealBreak = reducedMealBreak
      ? new ReducedMealBreakReasonRequestModel(reducedMealBreak)
      : null
  }
}

/**
 * Represents the reduced meal break details.
 */
export class ReducedMealBreakReasonRequestModel {
  /**
   * @param {Object} params
   * @param {string} params.option
   * @param {?any} params.value
   */
  constructor({ option, value }) {
    /**
     * The reason for the reduced meal break. Non-nullable.
     * @type {keyof ReducedMealBreakReasonOptions}
     */
    this.option = option

    /**
     * Additional value related to the reduced meal break. Nullable.
     * @type {?any}
     */
    this.value = value
  }
}
